import React from 'react'
import { getCaregiverSelectionFlags } from 'utils/caregiverUtils'
import '../stylesheets/VisitsPage.scss'
import ParticipantSelectionOverlay from 'components/ParticipantSelectionOverlay'
import UpcomingVisitsList from './UpcomingVisitsList'
import BlockingConsentModal from '../../Consent/components/BlockingConsentModal'

const VisitsPage = (props) => {
  const { showConsentModal, strings, user } = props

  const { mustSelectParticipant } = getCaregiverSelectionFlags({
    user,
    caregiver: props?.caregiver
  })
  // overlay is shared via ParticipantSelectionOverlay component
  // Note: The API is already called in the route definition (src/routes/Visits/index.js)
  // so we don't need to fetch it again in useEffect

  return (
    <div className='home page'>
      <BlockingConsentModal
        showConsentModal={showConsentModal}
        strings={strings}
      />
      <p>{strings.visits || 'Visits'}</p>
      {!showConsentModal && (
        <div className='linkt-container'>
          {mustSelectParticipant && <ParticipantSelectionOverlay />}
          <UpcomingVisitsList {...props} />
        </div>
      )}
    </div>
  )
}

VisitsPage.propTypes = {}

export default VisitsPage
